<template>
  <div>
    <el-row>
      <el-col>
        <!-- <div justify="center"> -->
        <!-- <el-alert
            class="center"
            v-if="this.currentCompany === 'MTR' || this.currentCompany === 'TB'"
            title="Esta tabla muestra el ultimo registro creado por el proceso de corte y reconexion"
            type="info"
            effect="dark"
            show-icon
            :closable="false"
          ></el-alert>
          <el-alert
            v-else
            title="No se muestran registros de corte y reconexion para esta compañia; solo para Magytrack"
            type="info"
            effect="dark"
            show-icon
            :closable="false"
          ></el-alert>
        </div> -->
      </el-col>
    </el-row>
    <!-- <el-button-group>
              <el-button type="primary" icon="el-icon-arrow-left" @click="toggleReport">Reporte GPS</el-button>
              <el-button type="primary" >Reporte Terminales<i class="el-icon-arrow-right el-icon-right"></i></el-button>
              <HistoryJobs v-if="showHistoryJobs" />
        </el-button-group> -->
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Reporte GPS" name="first">Reporte GPS</el-tab-pane>
      <el-tab-pane label="Reporte Terminales" name="second"
        >Reporte Terminales</el-tab-pane
      >
    </el-tabs> -->
    <rabbey-toolbox :filterables="true" @filter-search="handleSearch">
      <div class="mr-5">
        <el-select
          v-model="filterReason"
          placeholder="Filtra por la razon"
          size="mini"
          clearable
        >
          <el-option v-for="(v, index) in reasons2" :key="index" :value="v"
            >{{ v }}
          </el-option>
        </el-select>
      </div>
    </rabbey-toolbox>
    <div>
      <el-row type="flex" justify="space-around" :gutter="10">
        <el-col v-for="(value, key) in countReasons" :key="key">
          <CardStat
            :title="key"
            :val="value"
            icon="mdi mdi-checkbox-multiple-blank-outline"
          />
        </el-col>
      </el-row>

      <rabbey-table3
        :data="renderItems"
        :columns="columns"
        :loading="loading"
        :actions="actions"
        @rtable-push-action="handleCommand"
      />
      <customer-detail ref="details" />
    </div>
  </div>
</template>

<script>
import reportUsersToCut from "@/columns/reportUsersToCutncf";
import CardStat from "@/components/CardStat";
import moment from "moment";

export default {
  name: "ReportUsersToCut",
  components: {
    CardStat, //CustomerDetails,
    "customer-detail": () =>
      import(
        /* webpackChunkName: "CustomerDetail" */ "@/components/customers/CustomerDetail.vue"
      )
  },
  created() {
    this.fetchData();
  },
  data() {
    //let self = this;
    return {
      showHistoryJobs: false,

      customercode: {},
      clientData: {},
      loading: false,
      items: [],
      columns: reportUsersToCut,
      // TODO: Esto se configura en la vista que consulta este reporte, quizas esto deba ser mejorado.
      reasons2: [
        "Codigo cliente invalido",
        "Cliente no existe",
        "Contrato cerrado",
        "Mas de una factura vencida"
      ],
      search: "",
      filterReason: "",
      actions: [
        {
          command: "view-Client-Details",
          label: "Ver Detalle del Cliente",
          icon: "el-icon-view"
        },
        {
          command: "add-exception",
          label: "Agregar a exonerados de corte",
          icon: "el-e-plus",
          condition: () => this.IsInRole("CutterManager")
        },
        {
          command: "cut-client",
          label: "Cortar Cliente",
          icon: "el-icon-remove"
          // condition: () => this.IsInRole("CutterManager")
        },
        {
          command: "reconnect-client",
          label: "Reconectar Cliente",
          icon: "el-icon-success"
          // condition: () => this.IsInRole("CutterManager")
        }
      ],
      openDrawer: false
    };
  },
  computed: {
    /**
     * Unique reasons
     * @returns {*[]}
     */
    reasons() {
      const items = this.items.map((m) => m.reason);
      const seen = {};
      const out = [];
      const len = items.length;
      let j = 0;
      for (let i = 0; i < len; i++) {
        const item = items[i];
        if (seen[item] !== 1) {
          seen[item] = 1;
          out[j++] = item;
        }
      }
      return out;
    },
    /**
     * Reason count
     * @returns {{}}
     */
    countReasons() {
      let out = {};
      const reasons = this.reasons2;
      for (let i = 0; i < reasons.length; i++) {
        const reason = reasons[i];
        out[reason] = this.items.filter((f) => f.razon === reason).length;
      }
      return out;
    },
    renderItems() {
      const search = this.search;
      const filterReason = this.filterReason;
      let items = this.items;
      if (items == undefined || items == null || !items || items.length <= 0) {
        return [];
      }

      this.toggleLoading();
      const keys = Object.keys(this.items[0]);

      if (filterReason.length > 0) {
        items = items.filter((f) =>
          f.reason.toLowerCase().includes(filterReason.toLowerCase())
        );
      }

      if (search.length > 0) {
        items = items.filter((data) => {
          for (let i = 0; i < keys.length; i++) {
            let value = data[keys[i]];
            const valueType = typeof value;
            if (["number", "boolean"].includes(valueType)) {
              value = value.toString();
            }
            if (value && value.toLowerCase().includes(search.toLowerCase())) {
              return data;
            }
          }
        });
      }
      this.toggleLoading();
      return items;
    }
  },
  methods: {
    handleClick(tab) {
      if (tab.label == "Reporte GPS") {
        // console.log("esto aqui")
        this.toggleReport();
      }
    },
    toggleReport() {
      this.$router.push({ name: "record-cut-and-reconnection" });
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    fetchData() {
      this.loading = true;
      this.$http
        .get("/api/tennos/GetEmpresasCortadas")
        .then((response) => {
          // console.log("reportUsersToCut fetchData response: ",response)
          response.data.forEach((cuttedUsers) => {
            cuttedUsers.daysInactive =
              moment(new Date()).diff(cuttedUsers.cutAt, "days").toString() +
              " dias";
          });
          this.items = response.data;
          // console.log(this.items);
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    },
    handleSearch(search) {
      this.search = search;
    },

    handleCommand(action) {
      switch (action.command) {
        case "view-Client-Details": {
          //console.log("view-Client-Details action: ",action)
          this.$http
            .get(`/api/customers/${action.row.clientecode}`)
            .then((resp) => {
              this.$refs.details.show(resp.data);
              this.$refs.details.drawer = true;
            })
            .catch((error) => {
              this.$message.error("Error al consultar los clientes");
              console.error(error);
              this.contractNo = 0;
            });

          this.clientData = action.row;
          break;
        }
        case "cut-client": {
          this.loading = true;
          this.$http
            .put(`/api/tennos/CortarEmpresas?rnc=${action.row.rnc}`)
            .then((res) => {
              if (res.data === 1) {
                this.$message.success("Cliente Cortado!");
                this.fetchData();
              } else {
                this.$message.error("El cliente no fue agregado!");
              }

              this.loading = false;
            })
            .catch((err) => {
              console.error(err);
              this.loading = false;
            });
          break;
        }
        case "reconnect-client": {
          this.loading = true;
          this.$http
            .put(`/api/tennos/ReconexionEmpresas?rnc=${action.row.rnc}`)
            .then((res) => {
              if (res.data === 1) {
                this.$message.success("Cliente Reconectado!");
                this.fetchData();
              } else {
                this.$message.error("El cliente no fue reconectado!");
              }

              this.loading = false;
            })
            .catch((err) => {
              console.error(err);
              this.loading = false;
            });
          break;
        }
        //  case "add-exception": {
        //   this.loading = true;
        //   this.$http
        //     .post(
        //       "/api/ReconnectionAndExceptions/CreateReconnectionAndExceptions",
        //       {
        //         clientCode: action.row.post_region,
        //         companyCode: this.currentCompany,
        //         rnc: "",
        //         ClientName: action.row.first_name
        //       }
        //     )
        //     .then((res) => {
        //       if (res.data) {
        //         this.$message.success("Cliente agregado!");
        //         // Elimina lo de la lista
        //         const index = this.items.findIndex(
        //           (f) => f.navixy_id === action.row.navixy_id
        //         );
        //         if (index !== -1) {
        //           this.items.splice(index, 1);
        //         }
        //       } else {
        //         this.$message.error("El cliente no fue agregado!");
        //       }

        //       this.loading = false;
        //     })
        //     .catch((err) => {
        //       console.error(err);
        //       this.loading = false;
        //     });
        //   break;
        // }
        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
.center {
  content: center;
}
</style>
